module.exports = __webpack_public_path__ + "static/media/review.bdd1daa6.svg";